export function Values(obj){
    return Object.values(obj)
}

export function Keys(obj) {
    return Object.keys(obj)
}
export function Print(obj){
    return console.log(obj)
}
export function Merge(objA, objB){
    return Object.assign(objA, objB)
}
